module.exports = "<app-header></app-header>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 1